import React from 'react';
import classNames from 'classnames';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".UeLYb{flex:0 0 1px;height:100%}[dir] .UeLYb{background:#ededed}[dir=ltr] .UeLYb{margin:0 19px 0 9px}[dir=rtl] .UeLYb{margin:0 9px 0 19px}.sr4o0{display:block;height:1px;width:auto}[dir] .sr4o0{background:#ededed}[dir=ltr] .sr4o0{margin:0 -10px 0 -19px}[dir=rtl] .sr4o0{margin:0 -19px 0 -10px}";
var Styles = {"separator":"UeLYb","horizontalSeparator":"sr4o0"};
styleInject(css_248z);

const Separator = ({ className = "", horizontal = false }) => {
  const separatorClassNames = classNames(
    horizontal ? Styles.horizontalSeparator : Styles.separator,
    className
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: separatorClassNames,
      role: "separator",
      "aria-orientation": horizontal ? "horizontal" : "vertical"
    }
  );
};

export { Separator as default };
//# sourceMappingURL=Separator.js.map
